<template>
  <div>
    <SidebarView />

    <v-main>
      <div class="main-content-view" :style="main_content_style">
        <SidebarToggleView v-if="$route.path.endsWith('/app')" :solo="true" />
        <v-container fluid style="height: 100vh; max-height: 100%;">
          <router-view></router-view>
        </v-container>
      </div>
      <ActionImpossibleView
        actionType="CREATE"
        :showThis="show_company_create_disallowed"
        v-on:discard="show_company_create_disallowed = false"
      >
      </ActionImpossibleView>
      <ActionImpossibleView
        actionType="CREATE"
        entityType="PROC"
        :number="quota_number"
        :showThis="show_process_create_disallowed"
        v-on:discard="show_process_create_disallowed = false"
      >
      </ActionImpossibleView>
      <ActionImpossibleView
        actionType="UPDATE"
        entityType="PROC"
        :number="quota_number"
        :showThis="show_process_update_disallowed"
        v-on:discard="show_process_update_disallowed = false"
      >
      </ActionImpossibleView>
      <ActionImpossibleView
        actionType="UPLOAD"
        entityType="PROC"
        :number="quota_number"
        :showThis="show_template_upload_disallowed"
        v-on:discard="show_template_upload_disallowed = false"
      >
      </ActionImpossibleView>
    </v-main>
    <v-snackbar v-model="show_message" :bottom="true" :multi-line="true" :timeout="5000">
      {{ message_text }}
      <v-btn text @click="show_message = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import SidebarView from "./SidebarView";
import SidebarToggleView from "./SidebarToggleView";
import ActionImpossibleView from "./ActionImpossibleView";
import { AmplifyEventBus } from "aws-amplify-vue";
import { setTimeout } from "timers";
import ImprintFooterView from "./ImprintFooterView";

export default {
  name: "MainContentView",
  components: {
    SidebarView,
    SidebarToggleView,
    ActionImpossibleView,
    ImprintFooterView,
  },
  computed: {
    user_info() {
      return this.$store.state.originalStore.user_info;
    },
    main_content_style() {
      return "margin-left:" + (this.sidebarVisible ? "0px" : "20px") + ";";
    },
  },
  props: {
    msg: String,
  },
  data: () => ({
    show_message: false,
    message_text: "",
    retry_counter: 0,
    show_company_create_disallowed: false,
    show_process_create_disallowed: false,
    show_process_update_disallowed: false,
    show_template_upload_disallowed: false,
    quota_number: null,
    sidebarVisible: true,
  }),
  mounted() {
    this.after_connect(() => this.$store.dispatch("loadUserdata"));
    this.after_connect(this.catch_fresh_nopaymentoption_login);
  },
  methods: {
    after_connect(callback) {
      // will call the callback as soon as we are connected (i.e. user_info is loaded)
      if (!this.user_info) {
        this.retry_counter += 1;
        setTimeout(() => this.after_connect(callback), 200);
        return;
      }
      callback();
    },
    catch_fresh_nopaymentoption_login() {
      // catch the case where we do not have a payment_intent and also do not have active_product_id set on user.
      // this happens if we have a new user who created an account without going through the payment view.
      // we need to set active_product_id to the free plan here.
      var target_product_id = localStorage.getItem("payment_intent_product_id");
      if (
        (!target_product_id || target_product_id.startsWith("soda-free")) &&
        !this.user_info.attributes["custom:active_product_id"]
      ) {
        // hard coded product_id. should go to a plans manager
        var product_id = "soda-free-v1";

        // WARNING: the following snippet is doubled, also present in PurchaseView
        var cognito_user = this.$store.state.originalStore.cognito_user;
        this.$Amplify.Auth.updateUserAttributes(cognito_user, {
          "custom:active_product_id": product_id,
        })
          .then((res) => {
            AmplifyEventBus.$emit("updateAuthData", null);
          })
          .catch((err) => {
            console.error("error updating cognito user attribute", err);
          });
      }
    },
  },
  created() {
    this.$eventHub.on("show-company-create-disallowed", (msg) => {
      this.show_company_create_disallowed = true;
    });
    this.$eventHub.on("show-process-create-disallowed", (num) => {
      this.quota_number = num;
      this.show_process_create_disallowed = true;
    });
    this.$eventHub.on("show-process-update-disallowed", (num) => {
      this.quota_number = num;
      this.show_process_update_disallowed = true;
    });
    this.$eventHub.on("show-template-upload-disallowed", (num) => {
      this.quota_number = num;
      this.show_template_upload_disallowed = true;
    });
    //this.$eventHub.on('company-updated', (msg)=>{this.$store.dispatch('getCompanies'); this.message_text="Unternehmen "  + msg.name + " gespeichert."; this.show_message = true})
    //this.$eventHub.on('company-created', (msg)=>{this.$store.dispatch('getCompanies'); this.message_text="Unternehmen "  + msg.name + " erstellt."; this.show_message = true})
    //this.$eventHub.on('company-deleted', (msg)=>{this.$store.dispatch('getCompanies'); this.message_text="Unternehmen "  + msg.name + " gelöscht."; this.show_message = true})
    //this.$eventHub.on('process-updated', (msg)=>{this.message_text="Verfahren "  + msg.text_header + " gespeichert."; this.show_message = true})
    //this.$eventHub.on('process-created', (msg)=>{this.message_text="Verfahren "  + msg.text_header + " erstellt."; this.show_message = true})
    //this.$eventHub.on('process-deleted', (msg)=>{this.message_text="Verfahren "  + msg.text_header + " gelöscht."; this.show_message = true})
    //this.$eventHub.on('measureSet-updated', (msg)=>{this.message_text="Allgemeines TOM "  + msg.type + " gespeichert."; this.show_message = true})
    //this.$eventHub.on('measureSet-created', (msg)=>{this.message_text="Allgemeines TOM "  + msg.type + " erstellt."; this.show_message = true})
    //this.$eventHub.on('measureSet-deleted', (msg)=>{this.message_text="allgemeines TOM "  + msg.type + " gelöscht."; this.show_message = true})
    this.$eventHub.on("show-notification", (msg) => {
      this.message_text = msg.notification;
      this.show_message = true;
    });
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "SET_sidebarVisible") {
        this.sidebarVisible = state.originalStore.sidebarVisible;
      }
    });
  },
};
</script>

<style lang="scss" scoped></style>
